import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component, Fragment } from "react";
import Busy from "../../shared/busy";
import EmailPreview from "../../emailPreview/emailPreview";
import AdmissionsService from "../../../services/AdmissionService";
import TinyMCEMenuService from "../../../services/TinyMceMenuService";
import { AlertError } from "../../../src/View/UI/StandardAlerts/StandardAlerts";
import TinyMCEEditor from "../../../src/View/UI/TinyMce/tinyMceEditor";
export default class ApplicationReceiptConfirmationForm extends Component {
    constructor() {
        // @ts-expect-error - TS2554 - Expected 1-2 arguments, but got 0.
        super();
        this.handleInputChange = (event) => {
            const { target } = event;
            // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'EventTarget'. | TS2339 - Property 'checked' does not exist on type 'EventTarget'. | TS2339 - Property 'value' does not exist on type 'EventTarget'.
            const value = target.type === "checkbox" ? target.checked : target.value;
            // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'EventTarget'.
            const { name } = target;
            this.setState((prevState) => ({
                formValues: Object.assign(Object.assign({}, prevState.formValues), { [name]: value }),
                saving: Object.assign(Object.assign({}, prevState.saving), { saved: false }),
            }));
        };
        this.handleSendToEmailType = (event) => {
            // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'EventTarget'.
            const value = event.target.value;
            this.setState((prevState) => ({
                formValues: Object.assign(Object.assign({}, prevState.formValues), { sendToInstitutional: value === "true" }),
                saving: Object.assign(Object.assign({}, prevState.saving), { saved: false }),
            }));
        };
        this.handleBodyChange = (content) => {
            this.setState((prevState) => ({
                formValues: Object.assign(Object.assign({}, prevState.formValues), { body: content }),
                saving: Object.assign(Object.assign({}, prevState.saving), { saved: false }),
            }));
        };
        this.handleSubmit = (event) => {
            event.preventDefault();
            this.setState({
                saving: {
                    isSaving: true,
                    hasError: false,
                    errorMessage: "",
                    saved: false,
                },
            });
            AdmissionsService.updateApplicationreceiptConfirmationConfiguration(this.state.formValues)
                .then((savedConfig) => {
                this.setState({
                    saving: {
                        isSaving: false,
                        hasError: false,
                        errorMessage: "",
                        saved: true,
                    },
                });
            })
                .catch((error) => {
                this.setState({
                    saving: {
                        isSaving: false,
                        hasError: true,
                        errorMessage: typeof error === "string"
                            ? error
                            : "There was an error saving those changes.",
                        saved: false,
                    },
                });
            });
        };
        // Include this in useless constructor because flow barfs if I set
        // state outside of a constructor
        this.state = {
            formValues: {
                subject: "",
                body: "",
                isActive: true,
                ageThreshold: 24,
                sendToInstitutional: false,
                sendFromName: "",
            },
            loading: {
                isLoading: true,
                hasError: false,
                errorMessage: "",
            },
            saving: {
                isSaving: false,
                hasError: false,
                errorMessage: "",
                saved: false,
            },
            tinyMCEMenu: {
                isLoading: true,
                menus: [],
            },
        };
    }
    componentDidMount() {
        // Load in values.
        AdmissionsService.getApplicationReceiptConfirmationConfiguration()
            .then((config) => {
            this.setState({
                formValues: {
                    isActive: config.isActive,
                    sendToInstitutional: config.sendToInstitutional,
                    subject: config.subject || "",
                    body: config.body || "",
                    ageThreshold: config.ageThreshold || 24, // Default to 24 hours
                    sendFromName: config.sendFromName || "",
                },
                loading: {
                    isLoading: false,
                    hasError: false,
                    errorMessage: "",
                },
            });
        })
            .catch((error) => this.setState({
            loading: {
                isLoading: false,
                hasError: true,
                errorMessage: typeof error === "string" ? error : null,
            },
        }));
        TinyMCEMenuService.getApplicationReceiptConfirmationMenu().then((menus) => {
            this.setState({
                tinyMCEMenu: {
                    isLoading: false,
                    menus,
                },
            });
        });
    }
    renderSaveButton() {
        let buttonIcon;
        let buttonText;
        if (this.state.saving.isSaving) {
            buttonIcon = _jsx(Busy, { isBusy: true });
            buttonText = "Saving";
        }
        else if (this.state.saving.saved) {
            buttonIcon = _jsx("span", { className: "far fa-check" });
            buttonText = "Saved";
        }
        else {
            buttonIcon = _jsx("span", { className: "fas fa-save" });
            buttonText = "Save";
        }
        return (_jsxs("button", { className: "btn btn-primary", disabled: this.state.saving.isSaving || this.state.saving.saved, children: [buttonIcon, " ", buttonText] }));
    }
    render() {
        if (this.state.loading.isLoading) {
            return (_jsx("h1", { className: "d-flex align-items-center justify-content-center", children: _jsx(Busy, { isBusy: true }) }));
        }
        return (_jsx(Fragment, { children: _jsxs("form", { onSubmit: this.handleSubmit, children: [_jsxs("div", { className: "form-group", children: [_jsxs("div", { className: "custom-control custom-checkbox", children: [_jsx("input", { type: "checkbox", className: "custom-control-input", id: "customCheck1", name: "isActive", onChange: this.handleInputChange, checked: this.state.formValues.isActive }), _jsx("label", { className: "custom-control-label", htmlFor: "customCheck1", children: "Active" })] }), _jsx("small", { className: "text-muted", children: "If not active, no confirmation emails will be sent." })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "subject", children: "Subject" }), _jsx("input", { className: "form-control", type: "text", name: "subject", autoComplete: "off", 
                                // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string | number | readonly string[] | undefined'.
                                value: this.state.formValues.subject, onChange: this.handleInputChange })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "body", children: "Body" }), !this.state.tinyMCEMenu.isLoading && (_jsx(TinyMCEEditor, { name: "body", onEditorChange: this.handleBodyChange, value: this.state.formValues.body, 
                                // @ts-expect-error - TS2322 - Type 'TemplateMenu' is not assignable to type 'TemplateMenuItem[]'.
                                menus: this.state.tinyMCEMenu.menus, addDollarSignToVariables: true }))] }), _jsx("div", { className: "form-group", children: _jsx(EmailPreview, { getSubject: () => 
                            // We escape HTML here, so we can prevent blind XSS on this field when rendered by the preview
                            AdmissionsService.getApplicationReceiptConfirmationEmailPreview(this.state.formValues.subject || "", true), getBody: () => 
                            // The body value comes from a Tiny MCE Editor input which escapes HTML before submit, so we don't need to escape it here
                            AdmissionsService.getApplicationReceiptConfirmationEmailPreview(this.state.formValues.body || "", false), modalId: "previewModal" }) }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "ageThreshold", children: "Age Threshold" }), _jsxs("div", { className: "input-group mb-1 w-25", children: [_jsx("input", { className: "form-control", type: "number", min: 0, name: "ageThreshold", 
                                        // @ts-expect-error - TS2322 - Type 'number | null | undefined' is not assignable to type 'string | number | readonly string[] | undefined'.
                                        value: this.state.formValues.ageThreshold, onChange: this.handleInputChange }), _jsx("div", { className: "input-group-append", children: _jsx("div", { className: "input-group-text", children: "hours" }) })] }), _jsx("small", { className: "text-muted", children: "Only send email confirmations to students who have applied within this threshold. This setting is especially important when turning this feature from inactive to active." })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "sendToEmailType", children: "Send to Email Type" }), _jsxs("div", { children: [_jsxs("div", { className: "custom-control custom-radio custom-control-inline", children: [_jsx("input", { name: "sendToEmailType", id: "Institutional", type: "radio", 
                                                // @ts-expect-error - TS2322 - Type 'true' is not assignable to type 'string | number | readonly string[] | undefined'.
                                                value: true, className: "custom-control-input", onChange: this.handleSendToEmailType, checked: this.state.formValues.sendToInstitutional }), _jsx("label", { className: "custom-control-label", htmlFor: "Institutional", children: "Institutional" })] }), _jsxs("div", { className: "custom-control custom-radio custom-control-inline", children: [_jsx("input", { name: "sendToEmailType", id: "Personal", type: "radio", 
                                                // @ts-expect-error - TS2322 - Type 'false' is not assignable to type 'string | number | readonly string[] | undefined'.
                                                value: false, className: "custom-control-input", checked: !this.state.formValues.sendToInstitutional, onChange: this.handleSendToEmailType }), _jsx("label", { className: "custom-control-label", htmlFor: "Personal", children: "Personal" })] })] })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "sendFromName", children: "Send From Name" }), _jsx("input", { type: "text", className: "form-control", "aria-label": "Send From Name", id: "sendFromName", name: "sendFromName", 
                                // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string | number | readonly string[] | undefined'.
                                value: this.state.formValues.sendFromName, onChange: this.handleInputChange, autoComplete: "off" }), _jsx("small", { className: "text-muted", children: "The name that confirmation emails will appear to be from. If no name is provided, the emails will be sent from \"Aviso System\"" })] }), this.state.saving.hasError && (_jsx(AlertError, { message: "There was an error saving that config", 
                        // @ts-expect-error - TS2322 - Type '{ message: string; details: string | null | undefined; }' is not assignable to type 'IntrinsicAttributes & CannedAlertProps'.
                        details: this.state.saving.errorMessage })), this.renderSaveButton()] }) }));
    }
}
